import { render, staticRenderFns } from "./VLanguageField.vue?vue&type=template&id=9079b470"
import script from "./VLanguageField.vue?vue&type=script&lang=ts"
export * from "./VLanguageField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports